import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  paper: {
    backgroundColor: '#FFF',
    border: '1px solid #E5E5E5',
    boxSizing: 'border-box',
    borderRadius: '3px',
    width: '400px',
    maxHeight: '644px'
  },
  root: {
    padding: '0px'
  },
  subheader: {
    color: '#000000',
    fontSize: '13px',
    position: 'relative',
    lineHeight: '18px',
    paddingTop: '9px',
    fontWeight: 'bold'
  },
  notesLabel: {
    borderTop: '1px solid #E5E5E5',
    display: 'flex',
    alignItems: 'center',

    '& div:first-child': {
      marginRight: 10
    }
  },
  listItem: {
    color: '#000000',
    fontSize: '13px',
    paddingTop: '8px',
    fontWeight: 'lighter',
    borderBottom: '1px solid #E5E5E5'
  },
  unitTitle: {
    padding: '0px 40px 8px',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '18px',
    fontSize: '13px'
  },
  title: {
    lineHeight: '18px',
    fontSize: '15px',
    fontWeight: 'bold',
    padding: '40px 40px 12px'
  },
  unitIcon: {
    fill: '#0E8BB4',
    paddingRight: '10px'
  },
  closeBtn: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '10px'
  },
  actionBtnRoot: {
    boxShadow: 'none',
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    backgroundColor: '#0e8bb4',
    color: '#FFFFFF',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    padding: '8px 15px',
    minWidth: '80px',
    marginRight: '8px',
    '&:hover': {
      backgroundColor: '#0e8bb4',
      color: '#FFFFFF'
    }
  },
  cancelBtnRoot: {
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    color: '#0e8bb4',
    padding: '8px 15px',
    minWidth: '70px',
    marginRight: '16px'
  },
  closeIcon: {
    fontSize: '17px',
    color: '#000'
  },
  contentRoot: {
    padding: '0px 24px',
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#C2C2C2',
      borderRadius: '2px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#666666',
      opacity: 0.48,
      borderRadius: '2px'
    }
  },
  actionsRoot: {
    marginTop: '16px',
    borderTop: '1px solid #E5E5E5'
  }
});

export default useStyles;
